import React, { Component } from 'react';
import { LANGUAGES } from '../_i18n/languages'
import translations from '../_i18n/translations.json'

import { FormattedMessage, injectIntl, IntlProvider } from 'react-intl';

class LangCheck extends Component {

    state = { showLangNotify: false }

    componentDidMount() {
        const detectBrowserLanguage = require('detect-browser-language')
        this.setState({ userLanguage: String(detectBrowserLanguage()).split("-")[0] })
        setTimeout(() => {
            this.setState({ showLangNotify: true })
            setTimeout(() => this.setState({ showLangNotify: false }), 15000)
        }, 2000)
    }

    render() {
        return (
            <React.Fragment>
                {!this.checkLanguage() && this.state.showLangNotify ?
                    <IntlProvider locale="en" defaultLocale="en" messages={translations[LANGUAGES[this.state.userLanguage]['code']]}>
                        &nbsp;&nbsp;
                        <span className="blink" role="img" aria-label="Green Tick">✅</span>
                        &nbsp;&nbsp;
                        <span className="font-weight-bold blink">
                            <a href={(this.props.location.pathname.split('/')[1].length <= 2 ?
                                `/${this.state.userLanguage}` :
                                `/${this.props.location.pathname.split('/')[1]}/${this.state.userLanguage}`)
                                + (this.props.paramPath ? `/${this.props.paramPath}` : '')
                            }>
                                <FormattedMessage id="body.lang.suggest" /> {this.state.userLanguage.toUpperCase()}</a>
                        </span>
                    </IntlProvider>
                    : ''}
            </React.Fragment>
        )
    }

    checkLanguage() {
        let usrLang = this.state.userLanguage
        let urlLang = this.props.location.pathname.split('/')[2] ?
            this.props.location.pathname.split('/')[2] :
            this.props.location.pathname.split('/')[1] === usrLang ? usrLang : 'en'
        if (!LANGUAGES[usrLang])
            return true
        return usrLang === urlLang
    }

    static pathLocation(props, country) {
        let aPath = props.location.pathname.split('/')
        if (aPath[1]) {
            return `/${aPath[1]}${country ? '/' : ''}${country}${aPath[3] ? '/' + aPath[3] : ''}`
        }
        return `/${country}`
    }
}

export default injectIntl(LangCheck);